import { Link } from "react-router";
import { useBootstrapQuery, usePaymentsConfigQuery } from "../../api/queries";
import { PageShell } from "../../ui/PageShell";
import { MyOrdersList } from "../../ui/checkout/MyOrdersList";

/** `/orders`: the account's dollar purchases (Townsy Credit and card), each with its receipt. "Test mode" only in Stripe test mode (ADR-0046). */
export function OrdersPage() {
  const boot = useBootstrapQuery();
  const config = usePaymentsConfigQuery();
  const signedIn = Boolean(boot.data?.session.userId);
  const live = config.data?.mode === "live";
  return (
    <PageShell title="My orders" narrow>
      <p className="muted">
        Purchases paid with Townsy Credit and/or a card. Every order page is its receipt and shows the live state, including any refund to
        your card.{live ? " Sales tax, when charged, is shown on each receipt and paid by card." : " Stripe test mode: no real money moves."}
      </p>
      {boot.isPending ? <p className="muted">Loading your session…</p> : <MyOrdersList signedIn={signedIn} />}
      <p style={{ marginTop: 20 }}>
        <Link to="/">Back to the town</Link> · <Link to="/account">Account</Link>
      </p>
    </PageShell>
  );
}
